import { Box, Button, Container } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import {
  IMediaRecorder,
  MediaRecorder,
  register,
} from "extendable-media-recorder";
import { connect } from "extendable-media-recorder-wav-encoder";
import { makeStyles } from "@mui/styles";
import ParticipantList from "./components/ParticipantList/ParticipantList";
import clsx from "clsx";
import useConnectionOptions from "./utils/useConnectionOptions/useConnectionOptions";
import Video, {
  ConnectOptions,
  LocalAudioTrack,
  LocalTrack,
  LocalVideoTrack,
  Room,
} from "twilio-video";
import MicIcon from "./icons/MicIcon";
import MicOffIcon from "./icons/MicOffIcon";
import MainParticipant from "./components/MainParticipant/MainParticipant";
import { useNavigate } from "react-router-dom";

let isMuted = false;

let room: any;
let localDataTrack: any;

const useStyles = makeStyles((theme) => {
  const totalMobileSidebarHeight = `${90 + 8 * 2 + 2}px`;
  return {
    container: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingTop: 65,
      paddingBottom: 68,
      position: "relative",
      // maxHeight: 'calc(100vh - 64px)',
      // minHeight: 'calc(100vh - 64px)',
      maxHeight: "85vh",
      minHeight: "85vh",
      display: "flex",
      background: "#E3E3E3 !important",
      gridTemplateColumns: `1fr 300px`,
      gridTemplateRows: "100%",

      "@supports (-moz-appearance:none)": {
        overflow: "hidden",
      },
    },
    rightDrawerOpen: { gridTemplateColumns: `1fr 300px 320px` },
    calWidthEncounterWindow: {
      maxWidth: "calc(100% - 450px)",
    },
    calWidthWindow: {
      maxWidth: "calc(100% - 300px)",
    },
    calWidthVideoSettingsWindow: {
      maxWidth: "calc(100% - 400px)",
    },
    button: {
      background: "#EB3E3E !important",
      color: "white !important",
      "&:hover": {
        background: "#600101 !important",
      },
    },
  };
});
declare global {
  interface Window {
    Twilio: any;
    room: Room;
  }
}

const VideoCall = () => {
  const classes = useStyles();
  const connectionOptions = useConnectionOptions();
  const countRef = React.useRef(0);
  const navigate = useNavigate();

  const [accessToken, setAccessToken] = useState<string | null>(null);
  const [room, setRoom] = useState<Room | null>(null);
  const [isConnecting, setIsConnecting] = useState(false);
  const [audioTrack, setAudioTrack] = useState<LocalAudioTrack>();
  const [videoTrack, setVideoTrack] = useState<LocalVideoTrack>();

  useEffect(() => {
    if (countRef.current === 0) {
      countRef.current = 1;
      (async function fetchToken() {
        const audiotrace = await Video.createLocalAudioTrack().then(
          (newTrack: LocalAudioTrack) => {
            setAudioTrack(newTrack);
            return newTrack;
          }
        );
        const videoTrace = await Video.createLocalVideoTrack({
          facingMode: "user",
        }).then((newTrack: LocalVideoTrack) => {
          return newTrack;
        });

        await startRoom(videoTrace, audiotrace);
      })();
    }
    return () => {
      setAccessToken("");
    };
  }, []);

  const startRoom = async (videoTrace, audiotrace) => {
    const roomName = "myRoom1";
    setIsConnecting(true);
    await fetch(
      process.env.REACT_APP_API_BASE_URL +
        `/meeting/GenerateToken?roomId=${roomName}&&userName=${Math.random()}`,
      {
        method: "GET",
      }
    )
      .then(async (response: any) => {
        const token = await response.json();
        setAccessToken(token);
        await joinVideoRoom(roomName, token, videoTrace, audiotrace);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const joinVideoRoom = async (
    roomName: string,
    token: string,
    videoTrace,
    audiotrace
  ) => {
    localDataTrack = new Video.LocalDataTrack();
    try {
      await Video.connect(token, {
        ...connectionOptions,
        name: roomName,
        tracks: [videoTrace, audiotrace, localDataTrack],
      }).then((newRoom) => {
        console.log("newRoom", newRoom);
        // window.room = newRoom;
        setRoom(newRoom);
        window.Twilio.VideoRoomMonitor.registerVideoRoom(newRoom);
        const disconnect = () => newRoom.disconnect();

        // This app can add up to 13 'participantDisconnected' listeners to the room object, which can trigger
        // a warning from the EventEmitter object. Here we increase the max listeners to suppress the warning.
        newRoom.setMaxListeners(15);

        // newRoom.once("disconnected", () => {
        //   // Reset the room only after all other `disconnected` listeners have been called.
        //   setTimeout(() => setRoom(null));
        //   window.removeEventListener("beforeunload", disconnect);
        // });

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.twilioRoom = newRoom;

        newRoom.localParticipant.videoTracks.forEach((publication) =>
          // All video tracks are published with 'low' priority because the video track
          // that is displayed in the 'MainParticipant' component will have it's priority
          // set to 'high' via track.setPriority()
          publication.setPriority("low")
        );

        setIsConnecting(false);

        // Add a listener to disconnect from the room when a user closes their browser
        window.addEventListener("beforeunload", disconnect);
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleMuteUnmute = () => {
    if (!room) return;

    isMuted = !isMuted;

    room.localParticipant.audioTracks.forEach(
      (trackPublication: {
        track: { disable: () => void; enable: () => void };
      }) => {
        if (isMuted) {
          trackPublication.track.disable();
        } else {
          trackPublication.track.enable();
        }
      }
    );

    // Update UI state for mute/unmute
    const muteButton = document.getElementById("btnMuteUnmute");
    if (muteButton) {
      const icon = muteButton.querySelector("i");
      muteButton.classList.toggle("btn-danger", !isMuted);
      muteButton.classList.toggle("btn-success", isMuted);
      if (icon) {
        icon.classList.toggle("bi-mic-mute-fill", !isMuted);
        icon.classList.toggle("bi-mic-fill", isMuted);
      }
    }
  };

  const hangUp = () => {
    if (room) {
      room.disconnect();
      navigate("/ai-assistant");
      // window.location.href = "https://www.twilio.com/en-us/video";
    }
  };
  const toggleAudioEnabled = React.useCallback(() => {
    if (audioTrack) {
      audioTrack.isEnabled ? audioTrack.disable() : audioTrack.enable();
    }
    setAudioTrack(audioTrack);
  }, [audioTrack]);
  console.log("room", room);
  return (
    <>
      {!room ? (
        <p style={{ fontSize: "50px" }}>Connecting..................</p>
      ) : (
        <Container>
          <div className={clsx(classes.container, "main-content")}>
            <MainParticipant room={room} />
            <ParticipantList room={room} />
          </div>
          <div
            style={{ display: "flex", justifyContent: "center", marginTop: 15 }}
          >
            <Button
              className="btn-navigate"
              onClick={toggleAudioEnabled}
              data-cy-audio-toggle
            >
              {audioTrack?.isEnabled ? <MicIcon /> : <MicOffIcon />}
            </Button>
            <Button
              onClick={() => hangUp()}
              className={classes.button}
              data-cy-disconnect
            >
              Disconnect
            </Button>
          </div>
        </Container>
      )}
    </>
  );
};

export default VideoCall;
